import React, { useMemo } from "react";
import { SHTableCell } from "@components/design-systems";
import { Cell, flexRender } from "@tanstack/react-table";
import { useTheme } from "@mui/material";
import { ModelScreenerRow } from "@models/model-screener/entities/modelScreenerData";
import { MSTableDefaultSizeConstants } from "@pages/managed-accounts/model-screener/constant";

type MSTableStickyCellProps = {
  cell: Cell<ModelScreenerRow, unknown>;
};

export const MSTableStickyCell = React.memo(
  ({ cell }: MSTableStickyCellProps) => {
    const { palette } = useTheme();

    const columnData = cell?.column;
    const metaData = columnData?.columnDef?.meta;
    const rowIndex = cell?.row?.index;

    const cellContent = useMemo(
      () => flexRender(columnData?.columnDef?.cell, cell?.getContext()),
      [columnData?.columnDef?.cell, cell],
    );

    const cellStyle: React.CSSProperties = useMemo(
      () => ({
        position: "sticky",
        display: "flex",
        left: columnData?.getStart(),
        width: columnData?.getSize(),
        flexShrink: 0,
        height: MSTableDefaultSizeConstants.CellHeight,
        alignItems: "center",
        padding: "10px",
        borderRight: metaData?.isLastColumn
          ? `1px solid ${palette.divider}`
          : undefined,
        backgroundColor: rowIndex % 2 === 0 ? palette.secondary[50] : "white",
        opacity: 1,
        zIndex: 2,
      }),
      [columnData, metaData, rowIndex, palette.divider, palette.secondary],
    );

    return <SHTableCell style={cellStyle}>{cellContent}</SHTableCell>;
  }
);
